package com.partejar.app.feature.account.presentation

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.partejar.app.core.security.AppLockCoordinator
import com.partejar.app.core.session.SessionCoordinator
import com.partejar.app.feature.account.data.AccountDeletionReceipt
import com.partejar.app.feature.account.data.AccountDeletionRepository
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

sealed interface AccountDeletionState {
    data object Ready : AccountDeletionState
    data object Confirming : AccountDeletionState
    data object Loading : AccountDeletionState
    data class Success(val receipt: AccountDeletionReceipt) : AccountDeletionState
    data class Error(val message: String) : AccountDeletionState
}

class AccountDeletionViewModel(
    private val repository: AccountDeletionRepository,
    private val sessionCoordinator: SessionCoordinator,
    private val appLockCoordinator: AppLockCoordinator
) : ViewModel() {
    private val _state = MutableStateFlow<AccountDeletionState>(AccountDeletionState.Ready)
    val state: StateFlow<AccountDeletionState> = _state.asStateFlow()

    fun begin() {
        if (_state.value == AccountDeletionState.Ready || _state.value is AccountDeletionState.Error) {
            _state.value = AccountDeletionState.Confirming
        }
    }

    fun cancel() {
        if (_state.value == AccountDeletionState.Confirming) {
            _state.value = AccountDeletionState.Ready
        }
    }

    fun confirm(onSuccess: (AccountDeletionReceipt) -> Unit) {
        if (_state.value != AccountDeletionState.Confirming) return
        _state.value = AccountDeletionState.Loading
        viewModelScope.launch {
            val receipt = try {
                repository.request()
            } catch (error: CancellationException) {
                throw error
            } catch (_: Throwable) {
                _state.value = AccountDeletionState.Error("Não foi possível registrar a solicitação. Tente novamente.")
                return@launch
            }
            try {
                sessionCoordinator.clearLocalSession()
                appLockCoordinator.returnToLogin()
            } catch (error: CancellationException) {
                throw error
            } catch (_: Throwable) {
                _state.value = AccountDeletionState.Error(
                    "Solicitação registrada, mas não foi possível limpar a sessão local. Feche o app e limpe os dados locais."
                )
                return@launch
            }
            _state.value = AccountDeletionState.Success(receipt)
            onSuccess(receipt)
        }
    }
}
